import { B } from '@angular/cdk/keycodes';
import { KeyValue } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ApiCallService } from '@app/services/api-call.service';
import { SEARCH_MODULES } from '@app/shared/constants/application-constants';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@Component({
    imports: [FormsModule, ReactiveFormsModule, SharedModule, RouterModule, MatAutocompleteModule],
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  panelOpenState = false;
  pageSize = 5;
  pageIndex = 0;
  allResults = []; // Store all results from API
  paginatedResults = []; // Store results for current page
  tags: Record<string, number> = {
    Candidates: 0,
    Customers: 0,
    Projects: 0,
    Courses: 0,
    Questions: 0,
    'Question Bank': 0,
    Leads: 0,
    Users: 0,
    Scheme: 0,
    'Assessment plan': 0,
    Rates: 0,
    'Question paper version': 0,
    'Industrial vertical': 0,
    'Business vertical': 0,
    'Course version': 0,
    'Question paper': 0,
    Invoices: 0,
    Bills: 0,
    Receipt: 0,
    Product: 0
  };

  sub: any;
  searchId: any;
  searchModule: any;
  isSearchInput = false;
  length = 0;
  options: string[] = [];
  searchInput: string = '';
  isSearching: boolean = false;
  recentSearches: any[] = [];
  private readonly RECENT_SEARCHES_KEY = 'searchPageRecentSearches';
  private readonly MAX_RECENT_SEARCHES = 10;
  private readonly RECENT_SEARCH_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  showAllRecentSearches: boolean = false;

  // Fields for each module
  moduleFields = {
    Users: [
      { label: 'Full Name', key: 'users_full_name' },
      { label: 'Phone', key: 'users_phone' },
      { label: 'Email', key: 'users_email' },
      { label: 'Users ID', key: 'users_id' },
      { label: 'Organization ID', key: 'organization_id' },
      { label: 'Username', key: 'users_username' },
      { label: 'Active', key: 'users_is_active' },
      { label: 'Created Date', key: 'users_created_datetime' },
      { label: 'Organization Name', key: 'users_org_name' },
      { label: 'Category Name', key: 'users_category_name' },
      { label: 'Role Name', key: 'role_name' },
      { label: 'Role Description', key: 'user_role_description' },
      { label: 'Reporting To', key: 'users_reporting_to', isArray: true },
    ],
    Scheme: [
      { label: 'Scheme Name', key: 'scheme_name' },
      { label: 'Scheme Code', key: 'scheme_code' },
      { label: 'Start Date', key: 'scheme_start_date' },
      { label: 'End Date', key: 'scheme_end_date' },
      { label: 'Funding Source', key: 'scheme_funding_source_name' },
      { label: 'Total Budget', key: 'scheme_total_budget_amount', isCurrency: true },
      { label: 'Scheme ID', key: 'scheme_id' },
      { label: 'Organization ID', key: 'organization_id' }
    ],
    Candidates: [
      { label: 'Candidate Name', key: 'candidate_full_name' },
      { label: 'Username', key: 'candidate_username' },
      { label: 'Email', key: 'candidate_email' },
    ],
    Project: [
      { label: 'Project Alias', key: 'project_alias' },
      { label: 'Project Short Name', key: 'project_short_name' },
      { label: 'Description', key: 'project_description' },
      { label: 'Project ID', key: 'project_id' },
      { label: 'Created By User ID', key: 'project_created_user_id' }
    ],
    Courses: [
      { label: 'Course Name', key: 'course_name' },
      { label: 'Course Code', key: 'course_code' },
      { label: 'Description', key: 'course_description' },
      { label: 'Course Framework name', key: 'course_framework_name' },
      { label: 'Created by User', key: 'course_created_by_user' },
      { label: 'Course Active', key: 'course_is_active' },
    ],
    Customer: [
      { label: 'Customer Name', key: 'customer_name' },
      { label: 'Customer GSTIN', key: 'customer_gstin' },
      { label: 'Customer PAN', key: 'customer_pan' },
      { label: 'Customer Address', key: 'customer_address' },
      { label: 'Customer ID', key: 'customer_id' },
    ],
    Questions: [
      { label: 'Question Text', key: 'questions_question_text' },
      { label: 'Additional Information', key: 'questions_additional_information' },
      { label: 'Hint', key: 'questions_question_hint' },
      { label: 'Feedback', key: 'questions_question_feedback' },
      { label: 'Remarks', key: 'questions_question_remarks' },
      { label: 'Question Type', key: 'questions_type_name' },
      { label: 'Difficulty Level', key: 'questions_difficulty_name' },
      { label: 'Evaluation Mode', key: 'questions_question_category' },
      { label: 'Course', key: 'questions_course_name' },
      { label: 'Course Version', key: 'questions_course_version_name' },
    ],
    'Assessment plan': [
      { label: 'Assessment Plan ID', key: 'assessment_plan_id' },
      { label: 'Title', key: 'assessment_plan_title' },
      { label: 'Description', key: 'assessment_plan_description' },
      { label: 'Instructions', key: 'assessment_plan_instructions' },
      { label: 'Address Line 1', key: 'assessment_plan_address_line1' },
      { label: 'Address Line 2', key: 'assessment_plan_address_line2' },
      { label: 'District', key: 'assessment_plan_district' },
      { label: 'State', key: 'assessment_plan_state' },
      { label: 'Pincode', key: 'assessment_plan_pincode' },
      { label: 'Start Date', key: 'assessment_plan_start_datetime' },
      { label: 'End Date', key: 'assessment_plan_end_datetime' }
    ],
    Leads: [
      { label: 'Lead Name', key: 'lead_name' },
      { label: 'Lead Address', key: 'lead_address' },
      { label: 'Lead Estimated Units', key: 'lead_estimated_units' },
      { label: 'Lead Estimated Revenue', key: 'lead_estimated_revenue', isCurrency: true },
      { label: 'Lead ID', key: 'lead_id' }
    ],
    Rates: [
      { label: 'Customer Name', key: 'rates_customer_name' },
      { label: 'Service', key: 'rates_service' },
      { label: 'Fee Type', key: 'rates_fee_type' },
      { label: 'Unit of Measure', key: 'rates_uom' },
      { label: 'Unit Rate', key: 'rates_unit_rate' },
      { label: 'Effective From', key: 'rates_effective_from' },
      { label: 'Effective To', key: 'rates_effective_to' },
      { label: 'Active', key: 'rates_is_active' }
    ],
    'Question paper': [
      { label: 'Question Paper ID', key: 'question_paper_id' },
      { label: 'Question Paper Title', key: 'question_paper_title' },
      { label: 'Organization ID', key: 'organization_id' }
    ],
    'Question paper version': [
      { label: 'Question Paper Version ID', key: 'question_paper_version_id' },
      { label: 'Name', key: 'question_paper_version_name' },
      { label: 'Short Name', key: 'question_paper_version_short_name' },
      { label: 'Course', key: 'question_paper_version_course_name' },
      { label: 'Course Version', key: 'question_paper_version_course_version_name' },
      { label: 'Instructions', key: 'question_paper_version_instructions' },
    ],
    'User Categories': [
      { label: 'Category Name', key: 'category_name' },
      { label: 'Category ID', key: 'user_category_id' },
      { label: 'Organization ID', key: 'organization_id' }
    ],
    'User Roles': [
      { label: 'Role Name', key: 'role_name' },
      { label: 'Description', key: 'user_role_description' },
      { label: 'Role ID', key: 'user_role_id' },
      { label: 'Organization ID', key: 'organization_id' }
    ],

    // 'Question bank': [
    //   { label: 'Question Bank ID', key: 'question_bank_id' },
    //   { label: 'Title', key: 'question_bank_title' },
    //   { label: 'Course Framework Name', key: 'question_bank_course_framework_name' },
    //   { label: 'Course Name', key: 'question_bank_course_name' },
    //   { label: 'Active', key: 'question_bank_is_active' },
    //   { label: 'Archived', key: 'question_bank_is_archived' }
    // ],
    'Industrial vertical': [
      { label: 'Industrial Vertical ID', key: 'industrial_vertical_id' },
      { label: 'Name', key: 'industrial_vertical_name' },
      { label: 'Organization Name', key: 'industrial_vertical_organization_name' },
      { label: 'Active', key: 'industrial_vertical_is_active' },
      { label: 'Created Date', key: 'industrial_vertical_created_datetime' },
      { label: 'Modified Date', key: 'industrial_vertical_modified_datetime' }
    ],
    'Business vertical': [
      { label: 'Business Vertical ID', key: 'business_vertical_id' },
      { label: 'Name', key: 'business_vertical_name' },
      { label: 'Code', key: 'business_vertical_code' },
      { label: 'Description', key: 'business_vertical_description' },
      { label: 'Organization Name', key: 'business_vertical_organization_name' },
      { label: 'Active', key: 'business_vertical_is_active' }
    ],
    Opportunity: [
      { label: 'Opportunity', key: 'opportunity' },
      { label: 'Opportunity ID', key: 'opportunity_id' },
      { label: 'Organization ID', key: 'organization_id' }
    ],
    Organization: [
    { label: 'Organization Name', key: 'organization_name' },
    { label: 'Billing Address', key: 'billing_address' },
    { label: 'Organization ID', key: 'organization_id' }
  ],
    Invoices: [
      { label: 'Invoice Number', key: 'reference_no' },
      { label: 'Invoice ID', key: 'invoice_id' },
      { label: 'Party Name', key: 'party_name' },
      { label: 'Customer Name', key: 'customer_name' },
      { label: 'Invoice Date', key: 'invoice_date' },
      { label: 'Invoice Value', key: 'invoice_value' },
      { label: 'Status', key: 'status' },
      { label: 'Customer GSTIN', key: 'customer_gstin' },
      { label: 'Customer PAN', key: 'customer_pan' },
      { label: 'Customer Address', key: 'customer_address' },
      { label: 'Customer ID', key: 'customer_id' },
      { label: 'Organization ID', key: 'organization_id' }
    ],
    Bills: [
      { label: 'Bill ID', key: 'bills_id' },
      { label: 'Cost Category', key: 'bills_cost_category' },
      { label: 'Billed Amount', key: 'bills_billed_amount' },
      { label: 'Vendor Name', key: 'bills_vendor_name' },
      { label: 'Vendor Category', key: 'bills_vendor_category_name' },
      { label: 'Vendor Category ID', key: 'bills_vendor_category_id' },
      { label: 'Vendor ID', key: 'bills_vendor_id' },
    ],
    Products: [
      { label: 'Product Name', key: 'product_name' },
      { label: 'Product Code', key: 'product_code' },
      { label: 'Product Description', key: 'product_description' },
      { label: 'Product Active', key: 'product_is_active' },
      { label: 'Created Date', key: 'product_created_datetime' },
      { label: 'Organization Name', key: 'product_organization_name' },
    ],
    'Course Version': [
      { label: 'Course Version ID', key: 'course_version_id' },
      { label: 'Course Version Name', key: 'course_version_name' },
      { label: 'Alias', key: 'course_version_alias' },
      { label: 'Course Name', key: 'course_version_course_name' },
      { label: 'Organization Name', key: 'course_version_organization_name' },
      { label: 'Is Active', key: 'course_version_is_active' },
      { label: 'Created Date', key: 'course_version_created_datetime' },
      { label: 'Modified Date', key: 'course_version_modified_datetime' },
    ],
  };

  moduleRouterLinks = {
    Leads: '/Customer/Leads',
    AddLead: '/Customer/Leads',
    Customer: '/Customer/Customer',
    AddCustomer: '/Customer/Customer',
    Scheme: '/Customer/Scheme',
    Courses: '/Library/Courses',
    Questions: '/Library/Questions',
    Organization: '/admin/org-list',
    'Assessment plan': '/Assessments/AssessmentPlan',
    'Question paper version': '/Library/QuestionPapers',
    Bills: '/Finance/Bills',
    'User Roles': '/UserSettings/Roles',
    'User Categories': '/UserSettings/Categories',
    Invoices: '/Finance/Invoices',
    Receipt: '/Finance/Receipt',
    Candidates: '/Assessments/Candidate',
    Users: '/UserSettings/Users',
    Project: '/Operations/Project',
    Rates: '/Finance/RateMaster',
    'Question paper': '/Library/QuestionPapers',
    'Course Version': '/Library/Courses',
    IndustryVerticals: '/Setup/IndustryVerticals',
    BusinessVerticals: '/Setup/BusinessVerticals'
  };
  highlightSearchText(text: string, searchTerm: string): SafeHtml {
    if (!searchTerm || !text) {
      return text;
    }

    const lowerText = text.toLowerCase();
    const lowerSearchTerm = searchTerm.toLowerCase();
    const startIndex = lowerText.indexOf(lowerSearchTerm);

    if (startIndex === -1) {
      return text;
    }

    const endIndex = startIndex + searchTerm.length;
    const before = text.substring(0, startIndex);
    const match = text.substring(startIndex, endIndex);
    const after = text.substring(endIndex);

    const highlightedText = `${before}<strong class="highlighted-match">${match}</strong>${after}`;
    return this.sanitizer.bypassSecurityTrustHtml(highlightedText);
  }

  formatSearchFieldValue(field: any, value: any): string {
    if (value === null || value === undefined || value === '') {
      return 'None';
    }

    if (field?.key === 'questions_question_category') {
      const normalized = String(value).trim().toLowerCase();
      const displayMap: { [key: string]: string } = {
        theory: 'THEORY',
        viva: 'VIVA',
        practical: 'PRACTICAL'
      };

      return displayMap[normalized] || String(value).toUpperCase();
    }

    if (field?.key === 'question_paper_version_category') {
      return this.formatQuestionPaperVersionCategory(value);
    }

    if (Array.isArray(value) || typeof value === 'object') {
      return this.formatComplexValue(value);
    }

    return this.stripHtmlTags(String(value)) || 'None';
  }

  private formatQuestionPaperVersionCategory(category: any): string {
    if (!category || typeof category !== 'object' || Array.isArray(category)) {
      return this.formatComplexValue(category);
    }

    const sections = Object.entries(category)
      .map(([sectionName, sectionValue]) => this.formatQuestionPaperCategoryNode(sectionName, sectionValue))
      .filter((item) => item !== 'None');

    return sections.length ? sections.join(' ; ') : 'None';
  }

  private formatQuestionPaperCategoryNode(sectionName: string, sectionValue: any, prefix = ''): string {
    const sectionLabel = `${prefix}${sectionName}`;

    if (Array.isArray(sectionValue)) {
      const items = sectionValue
        .map((item) => this.formatQuestionPaperCategoryItem(item))
        .filter((item) => item !== 'None');

      return items.length ? `${sectionLabel}: ${items.join(' | ')}` : `${sectionLabel}: None`;
    }

    if (sectionValue && typeof sectionValue === 'object') {
      const nestedSections = Object.entries(sectionValue)
        .map(([innerSectionName, innerSectionValue]) =>
          this.formatQuestionPaperCategoryNode(innerSectionName, innerSectionValue, `${sectionLabel} > `)
        )
        .filter((item) => item !== 'None');

      return nestedSections.length ? nestedSections.join(' ; ') : `${sectionLabel}: None`;
    }

    return `${sectionLabel}: ${this.formatComplexValue(sectionValue)}`;
  }

  private formatQuestionPaperCategoryItem(item: any): string {
    if (!item || typeof item !== 'object') {
      return this.formatComplexValue(item);
    }

    const labelNames = Array.isArray(item.labelName) ? item.labelName.join(', ') : this.formatComplexValue(item.labelName);
    const marks = item.marks !== undefined && item.marks !== null ? `Marks: ${item.marks}` : '';
    const labelIds = Array.isArray(item.labelId) ? item.labelId.join(', ') : this.formatComplexValue(item.labelId);

    const parts = [
      labelNames && labelNames !== 'None' ? labelNames : '',
      labelIds && labelIds !== 'None' ? `Label ID: ${labelIds}` : '',
      marks,
    ].filter(Boolean);

    return parts.length ? parts.join(' | ') : 'None';
  }

  private formatComplexValue(value: any): string {
    if (value === null || value === undefined || value === '') {
      return 'None';
    }

    if (Array.isArray(value)) {
      return value
        .map((item) => this.formatComplexValue(item))
        .filter((item) => item !== 'None')
        .join(', ') || 'None';
    }

    if (typeof value === 'object') {
      const entries = Object.entries(value)
        .map(([key, item]) => {
          if (item === null || item === undefined || item === '') {
            return null;
          }

          return `${key}: ${this.formatComplexValue(item)}`;
        })
        .filter((item): item is string => !!item);

      return entries.length ? entries.join(', ') : 'None';
    }

    return this.stripHtmlTags(String(value)) || 'None';
  }

  getNormalizedModuleName(moduleName: string): string {
    const normalized = this.normalizeSearchText(moduleName).toLowerCase();

    if (!normalized) {
      return '';
    }

    const aliasMap: Record<string, string> = {
      candidate: 'Candidates',
      candidates: 'Candidates',
      question: 'Questions',
      questions: 'Questions',
      customer: 'Customer',
      users: 'Users',
      user: 'Users',
      project: 'Project',
      projects: 'Project',
      course: 'Courses',
      courses: 'Courses',
      scheme: 'Scheme',
      leads: 'Leads',
      lead: 'Leads',
      receipt: 'Receipt',
      invoices: 'Invoices',
      invoice: 'Invoices',
      bills: 'Bills',
      product: 'Products',
      products: 'Products',
      organization: 'Organization',
      opportunity: 'Opportunity',
      'course version': 'Course Version',
      'course versions': 'Course Version',
      rates: 'Rates',
      'question paper': 'Question paper',
      'question papers': 'Question paper',
      'question paper version': 'Question paper version',
      'assessment plan': 'Assessment plan',
      'industrial vertical': 'Industrial vertical',
      'business vertical': 'Business vertical',
      'user roles': 'User Roles',
      'user categories': 'User Categories',
    };

    return aliasMap[normalized] || moduleName;
  }

  getModuleFields(moduleName: string) {
    const key = this.getNormalizedModuleName(moduleName) as keyof typeof this.moduleFields;
    return this.moduleFields[key] || null;
  }

  getModuleRouterLink(moduleName: string): string {
    return this.moduleRouterLinks[this.getNormalizedModuleName(moduleName) as keyof typeof this.moduleRouterLinks] || '';
  }

  getModuleRouterCommands(moduleName: string): string[] | null {
    const link = this.getModuleRouterLink(moduleName);
    if (!link) {
      return null;
    }

    return ['/'].concat(link.split('/').filter(Boolean));
  }
  stripHtmlTags(text: string): string {
    if (!text) {
      return '';
    }
    // Create a temporary div to parse HTML
    const temp = document.createElement('div');
    temp.innerHTML = text;
    // Return the text content which removes all HTML tags
    return temp.textContent || temp.innerText || '';
  }

  constructor(
    private router: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private apiCallService: ApiCallService,
    private sanitizer: DomSanitizer

  ) { }

  ngOnInit(): void {
    this.loadRecentSearches();
    this.router.paramMap.subscribe(params => {
      this.sub = params.get('key');
      this.searchInput = this.normalizeSearchText(this.stripHtmlTags(this.sub || ''));
      this.searchModule = params.get('module');
      this.searchId = params.get('id');

      if (this.sub) {
        this.isSearchInput = true;
        this.fetchSearchResults(this.sub);
      } else {
        this.isSearchInput = false;
        this.allResults = [];
        this.paginatedResults = [];
        this.length = 0;
      }
    });
  }

  getModuleIdField(moduleName: string): string {
    switch (moduleName) {
      case 'Leads':
        return 'lead_id';
      case 'User Roles':
        return 'user_role_id';
      case 'User Categories':
        return 'user_category_id';
      case 'Customer':
        return 'customer_id';
      case 'Scheme':
        return 'scheme_id';
      case 'Courses':
        return 'course_id';
      case 'Questions':
        return 'questions_id';
      case 'Assessment plan':
        return 'assessment_plan_id';
      case 'Candidate':
      case 'Candidates':
        return 'candidate_id';
      case 'Products':
      case 'Product':
        return 'product_id';
      case 'Project':
        return 'project_id';
      case 'Users':
        return 'users_id';
      case 'Rates':
        return 'rates_id';
      case 'Question paper':
        return 'question_paper_id';
      case 'Course version':
      case 'Course Version':
        return 'course_version_id';
      case 'Receipt':
        return 'receipt_id';
      case 'Question paper version':
        return 'question_paper_version_id';
      case 'Business vertical':
        return 'business_vertical_id';
      case 'Industrial vertical':
        return 'industrial_vertical_id';
      case 'Question bank':
        return 'question_bank_id';
      case 'Product':
        return 'product_id';
      case 'Bills':
        return 'bills_id';
      case 'Invoices':
        return 'invoice_id';
      case 'Opportunity':
       return 'opportunity_id';
      case 'Organization':
       return 'organization_id';
      default:
        return 'unknown_id';
    }
  }

  convertToIST(utcDate: string): string {
    if (!utcDate) return 'None';

    const date = new Date(utcDate);
    return date.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
  }
  previousPage() {
    if (this.pageIndex > 0) {
      this.pageIndex--;
      this.updatePaginatedResults();
    }
  }

  nextPage() {
    const maxPage = Math.ceil(this.length / this.pageSize) - 1;
    if (this.pageIndex < maxPage) {
      this.pageIndex++;
      this.updatePaginatedResults();
    }
  }

  onPageSizeChange(event: any) {
    this.pageIndex = 0; // reset to first page
    this.pageSize = +event.target.value;
    this.updatePaginatedResults();
  }

  getStartIndex(): number {
    return this.pageIndex * this.pageSize;
  }

  getEndIndex(): number {
    const end = this.getStartIndex() + this.pageSize;
    return end > this.length ? this.length : end;
  }

  private loadRecentSearches(): void {
    const stored = localStorage.getItem(this.RECENT_SEARCHES_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        this.recentSearches = this.pruneExpiredRecentSearches(parsed);
      } catch (error) {
        console.error('Error parsing recent searches from localStorage:', error);
        this.recentSearches = [];
      }
    }
  }

  private saveRecentSearches(): void {
    this.recentSearches = this.pruneExpiredRecentSearches(this.recentSearches);
    localStorage.setItem(this.RECENT_SEARCHES_KEY, JSON.stringify(this.recentSearches));
  }

  private normalizeSearchText(text: string): string {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  formatRecentSearchLabel(search: any): string {
    const item = this.normalizeSearchText(search?.item);
    if (!item) {
      return '';
    }

    return search?.module ? `Search: ${item} in ${search.module}` : `Search: ${item}`;
  }

  private addToRecentSearches(item: string, module: string): void {
    const normalizedItem = this.normalizeSearchText(item);
    const normalizedModule = this.normalizeSearchText(module);

    if (!normalizedItem) {
      return;
    }

    // Remove existing entry if it exists
    this.recentSearches = this.recentSearches.filter(search => search.item !== normalizedItem);
    // Add new entry at the beginning
    this.recentSearches.unshift({ item: normalizedItem, module: normalizedModule, searchedAt: Date.now() });
    // Limit to max recent searches
    this.recentSearches = this.recentSearches.slice(0, this.MAX_RECENT_SEARCHES);
    // Save to localStorage
    this.saveRecentSearches();
  }

  private pruneExpiredRecentSearches(searches: any[]): any[] {
    const now = Date.now();

    return (Array.isArray(searches) ? searches : [])
      .map((search: any) => ({
        ...search,
        searchedAt: this.getRecentSearchTimestamp(search),
      }))
      .filter((search: any) => now - search.searchedAt <= this.RECENT_SEARCH_TTL_MS);
  }

  private getRecentSearchTimestamp(search: any): number {
    const ts = search?.searchedAt ?? search?.createdAt ?? search?.timestamp;
    const parsed = Number(ts);
    if (Number.isFinite(parsed) && parsed > 0) {
      return parsed;
    }

    return Date.now();
  }

 toggleRecentSearches(): void {
  this.showAllRecentSearches = !this.showAllRecentSearches;
}


  getDisplayedRecentSearches(): any[] {
  return this.showAllRecentSearches 
    ? this.recentSearches 
    : this.recentSearches.slice(0, 9);
}

  onRecentSearchClick(item: string): void {
    this.searchInput = this.normalizeSearchText(this.stripHtmlTags(item));
    this.searchModule = null;
    this.searchId = null;
    this.isSearchInput = true;
    this.pageIndex = 0; // Reset to first page on new search
    this.fetchSearchResults(this.searchInput);
  }

  removeRecentSearch(searchToRemove: any, event?: MouseEvent): void {
    event?.stopPropagation();

    const normalizedItem = this.normalizeSearchText(searchToRemove?.item);
    const normalizedModule = this.normalizeSearchText(searchToRemove?.module);

    this.recentSearches = this.recentSearches.filter(search => {
      const itemMatches = this.normalizeSearchText(search?.item) === normalizedItem;
      const moduleMatches = this.normalizeSearchText(search?.module) === normalizedModule;
      return !(itemMatches && moduleMatches);
    });

    this.saveRecentSearches();
  }

  fetchSearchResults(query: string): void {
    this.isSearching = true;
    const normalizedQuery = this.normalizeSearchText(query);
    this.apiCallService.searchQuery(normalizedQuery).subscribe(
      (response) => {
        if (response.body && response.body.data) {
          let temp = response.body.data;
          console.log(this.searchModule, this.searchId, 'before array', temp);

          if (this.searchModule) {
            const moduleMatches = response.body.data.filter((input: any) => this.moduleMatches(input?.module, this.searchModule));
            temp = moduleMatches.length ? moduleMatches : temp;

            if (this.hasValidSearchId(this.searchId)) {
              const idMatches = temp.filter((input: any) => {
                const tempModuleId = this.getModuleIdField(input?.module || this.searchModule);
                console.log('input', input.data);
                return String(input?.data?.[tempModuleId]) === String(this.searchId);
              });
              temp = idMatches.length ? idMatches : temp;
            }
          }

          if (!temp.length) {
            temp = response.body.data.filter((input: any) => this.matchesSearchText(input, normalizedQuery));
          }

          this.allResults = temp; // Store all results
          this.length = this.allResults.length;
          this.updatePaginatedResults(); // Update paginated view
          this.updateTags(this.allResults);
          console.log('all results', this.allResults);
          console.log('paginated results', this.paginatedResults);
          if (this.allResults.length > 0) 
            {
              this.addToRecentSearches(normalizedQuery, '');
          }
        } else {
          this.allResults = [];
          this.paginatedResults = [];
          console.warn('No data found in the API response.');
        }
        this.isSearching = false;
        this.changeDetectorRef.markForCheck();
      },
      (error) => {
        console.error('Error while searching', error);
        this.allResults = [];
        this.paginatedResults = [];
        this.isSearching = false;
      }
    );
  }

  updatePaginatedResults(): void {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedResults = this.allResults.slice(startIndex, endIndex);
  }

  updateTags(results: any[]): void {
    this.tags = this.resetTags();
    results.forEach((item) => {
      console.log("tags", item);
      if (item.module) {
        this.tags[item.module] = (this.tags[item.module] || 0) + 1;
      }
    });
  }

  onChangePage(pe: PageEvent) {
    this.pageIndex = pe.pageIndex;
    this.pageSize = pe.pageSize;
    this.updatePaginatedResults();
  }

  onInputChange() {
    if (this.searchInput.length >= 3) {
      this.isSearching = true;
      this.isSearchInput = true;
      this.pageIndex = 0; // Reset to first page on new search
      this.changeDetectorRef.markForCheck();
      this.fetchSearchResults(this.searchInput);
    } else {
      this.isSearching = false;
      this.changeDetectorRef.markForCheck();
      this.allResults = [];
      this.paginatedResults = [];
      this.tags = this.resetTags();
    }
  }

  search() {
    this.isSearchInput = true;
    this.pageIndex = 0; // Reset to first page on new search
    this.fetchSearchResults(this.searchInput);
  }

  orderOriginal = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return a.value > b.value ? -1 : (b.value > a.value ? 1 : 0);
  }

  private hasValidSearchId(searchId: any): boolean {
    return searchId !== null && searchId !== undefined && searchId !== '' && searchId !== 'undefined';
  }

  private moduleMatches(resultModule: string, selectedModule: string): boolean {
    if (!resultModule || !selectedModule) {
      return false;
    }

    const normalize = (value: string) => this.normalizeSearchText(value).toLowerCase();
    const result = normalize(resultModule);
    const selected = normalize(selectedModule);

    return result === selected || result === selected.replace(/s$/, '') || selected === result.replace(/s$/, '');
  }

  private matchesSearchText(result: any, query: string): boolean {
    const normalizedQuery = this.normalizeSearchText(query).toLowerCase();
    if (!normalizedQuery) {
      return false;
    }

    const itemMatches = this.normalizeSearchText(result?.item || '').toLowerCase().includes(normalizedQuery);
    const dataMatches = Object.values(result?.data || {}).some((value) => {
      return typeof value === 'string' && this.normalizeSearchText(value).toLowerCase().includes(normalizedQuery);
    });

    return itemMatches || dataMatches;
  }

  resetTags() {
    return {
      Candidates: 0,
      Customers: 0,
      Projects: 0,
      Courses: 0,
      Questions: 0,
      'Question Bank': 0,
      Leads: 0,
      Users: 0,
      Scheme: 0,
      'Assessment plan': 0,
      'user Roles': 0,
      'user Categories': 0,
      Rates: 0,
      'Question paper version': 0,
      'Industrial vertical': 0,
      'Business vertical': 0,
      'Course version': 0,
      'Question paper': 0,
      Invoices: 0,
      Bills: 0,
      Receipt: 0,
      Product: 0,
    };
  }
}
/**
 * <div class="container">
  <div class="row">
    <div class="col-lg-7 ml-4">
      <div class="input-group mb-3">
        <!-- Your search input code here -->
      </div>

      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of options" [value]="option">
          {{ option }}
        </mat-option>
      </mat-autocomplete>

      <div class="d-flex justify-content-between">
        <h2 *ngIf="isSearchInput; else recentSearches" style="color: #555;">
          Showing Result for: {{ searchInput }}
        </h2>
        <ng-template #recentSearches>
          <h2>Recent Searches (right below searchbar)</h2>
        </ng-template>
        <div class="all-results" *ngIf="!isSearching">All results ({{ length }})</div>
      </div>

      <div *ngIf="searchInput.length >= 3 && isSearching" class="searching-indicator">
        Searching...
      </div>

      <div *ngIf="!isSearching && paginatedResults.length === 0 && searchInput.length >= 3" class="no-results-message">
        No results found.
      </div>

      <div class="mt-1 accord">
        <mat-accordion>
          <div *ngFor="let search of paginatedResults">
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title>{{ search.item }}</mat-panel-title>
                <mat-panel-description *ngIf="search.module">
                  {{ search.module }}
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div *ngIf="moduleFields[search.module]">
                <ng-container *ngFor="let field of moduleFields[search.module]">
                  <p style="color: #555;font-size: 16px;font-weight: 500;" *ngIf="search.data[field.key]">
                    {{ field.label }}:
                    <span
                      *ngIf="field.key === 'assessment_plan_start_datetime' || field.key === 'assessment_plan_end_datetime'">
                      {{ convertToIST(search.data[field.key]) }}
                    </span>
                    <span
                      *ngIf="field.key !== 'assessment_plan_start_datetime' && field.key !== 'assessment_plan_end_datetime'">
                      {{ search.data[field.key] || 'None' }}
                    </span>
                  </p>
                </ng-container>

                <p *ngIf="moduleRouterLinks[search.module]">
                  <a [routerLink]="moduleRouterLinks[search.module]">
                    Go to {{ search.module }}
                  </a>
                </p>
              </div>
            </mat-expansion-panel>
          </div>
        </mat-accordion>

        <mat-paginator 
          [length]="length" 
          (page)="onChangePage($event)" 
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [pageSizeOptions]="[5, 10, 25]" 
          aria-label="Select page" 
          class="mb-5">
        </mat-paginator>
      </div>
    </div>
    <div class="col-lg-4 mt-2">
      <div class="d-flex justify-content-between" style="margin-top: 4px;">
        <h2 *ngIf="isSearchInput; else recentSearches" style="color: #555;font-weight: 600;">
          Recent Searches
        </h2>
      </div>

      <div class="box-search mt-2" *ngIf="isSearchInput">
        <div class="pr-3 mt-3">
          <div *ngFor="let search of recentSearches; let index = i">
            <div class="mb-3">
              <mat-icon class="mr-2">search</mat-icon>{{ search.item }}
              <span *ngIf="search.module" class="module">in {{ search.module }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
 */
